
function textNode(item, idx) {
	
	let node = {
			id: `${item.id}-${idx}-node`,
			name: item.prompt,
			nameVisible: true
		},
		slots = [{
			id: `${item.id}${idx}`.padEnd(64, '0'),
			type: "text",
			kind: "static",
			reference: "value",
			label: (item.type == 'text' ? "Text" : "Multi-line text"),
			required: item.required
		}],
		block = {
			type: (item.type == 'text' ? "@tripetto/block-text" : "@tripetto/block-textarea"),
			version: (item.type == 'text' ? "6.0.2" : "6.0.3"),
		};

	if (item.caption !== null && item.caption !== '') {
		block.caption = item.caption;
	}

	if (item.description !== null && item.description !== '') {
		node.description = item.description;
	}

	if (item.hasOwnProperty("maxChar") && item.maxChar !== ''){
		slots[0].maxLength = Number(item.maxChar);
		node.explanation = `Limit: ${item.maxChar} characters`
	}

	if (item.hasOwnProperty("minChar") && item.minChar !== ''){
		block.minLength = Number(item.minChar);
	}

	return {
		...node,
		slots,
		block
	};
}

export default textNode;